/** @format */
export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyBemtFxRmGBA-XtZ6AAs9vMGQJsZd9xQGI',
    authDomain: 'vietnam-food-1744e.firebaseapp.com',
    projectId: 'vietnam-food-1744e',
    storageBucket: 'vietnam-food-1744e.appspot.com',
    messagingSenderId: '846661255680',
    appId: '1:846661255680:web:ba83c7b11d4c59d26a0ee5',
    measurementId: 'G-8X738ZL9QR',
  },
};
